import { GetterTree, MutationTree, ActionTree, Module } from 'vuex';
import * as mutationTypes from './mutation-types';
import { StateConf } from './types';
import { balance, userInfo, detailPage } from '../api/index';

const state: StateConf = {
  userInfo: {},
  balanceC: 0,
  detailData: {},
};

const mutations: MutationTree<StateConf> = {
  // 余额修改方法
  [mutationTypes.GET_USER_BALANCE](state, balanceC) {
    let temp: string | number = balanceC.toString();
    if (temp === 'false') {
      temp = 0;
    } else {
      temp = Number(temp);
    }
    state.balanceC = temp;
  },
  // 用户信息的写入
  [mutationTypes.GET_USER_INFO](state, params) {
    state.userInfo = params;
  },
  // 详情页面信息
  [mutationTypes.GET_DETAIL_DATA](state, params) {
    state.detailData = params;
  },
  [mutationTypes.UPDATE_VOTE_NUM](state, params) {
    state.detailData.votes = params;
  },
  [mutationTypes.UPDATE_BALANCE](state, params) {
    state.balanceC = params;
  },
};

const actions: ActionTree<StateConf, any> = {
  // 余额接口action
  async fetchBalance({ commit, state }) {
    const res = await balance();
    commit(mutationTypes.GET_USER_BALANCE, res.data);
  },
  // 获取用户的信息
  async fetchUserInfo({ commit, state }) {
    const res = await userInfo();
    commit(mutationTypes.GET_USER_INFO, res.data);
  },
  // 获取详情页面数据
  async fetchDetail({ commit, state }, val: any) {
    state.detailData = {};
    const res = await detailPage(val);
    commit(mutationTypes.GET_DETAIL_DATA, res.data);
  },
};

const VoteForTopTenChongqingMerchants2019: Module<StateConf, any> = {
  namespaced: true,
  state,
  mutations,
  actions,
};

export default VoteForTopTenChongqingMerchants2019;
